import React, { Component } from 'react';
import {
	isEmpty, getIsShowSetpoint, getIsShowMode, getIsShowFanstep, getIsShowFlap, getIsShowVMode, getIsShowVAmount,
	getIsShowRcProhOp, getIsShowRcProhMode, getIsShowRcProhSP, getIsShowRcProhFanstep, getIsShowSB
} from '../../Common/Common';
import Switch from '../../Part_Sample/Switch';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';

import Command_Power from '../../Commands/Command_Power_On_Off';
import Command_Setpoint from '../../Commands/Command_Setpoint';
import Command_Hum_Setpoint from '../../Commands/Command_Hum_Setpoint';
import Command_Fanstep from '../../Commands/Command_Fanstep';
import Command_Flap from '../../Commands/Command_Flap';
import Command_Mode from '../../Commands/Command_Mode';
import Command_Level from '../../Commands/Command_Level';
import Command_Notification from '../../Commands/Schedule_Commands/Command_Notification';
import Command_Scene from '../../Commands/Interlock_Commands/Output/Command_Scene';
import Command_Schedule from '../../Commands/Interlock_Commands/Output/Command_Schedule';
import Command_Interlock from '../../Commands/Interlock_Commands/Output/Command_Interlock';
import Command_Off_Timer from '../../Commands/Schedule_Commands/Command_Off_Timer';
import Command_Setback_Cool from '../../Commands/Schedule_Commands/Command_Setback_Cool';
import Command_Setback_Heat from '../../Commands/Schedule_Commands/Command_Setback_Heat';
import Command_Lock from '../../Commands/Command_Lock';
import Command_Shutter from '../../Commands/Command_Shutter';
import Command_RGB_Input from '../../Commands/Command_RGB_Input';
import Command_RC_Proh_Op from '../../Commands/Command_RC_Proh_Op';
import Command_RC_Proh_Mode from '../../Commands/Command_RC_Proh_Mode';
import Command_RC_Proh_SP from '../../Commands/Command_RC_Proh_SP';
import Command_RC_Proh_Fanstep from '../../Commands/Command_RC_Proh_Fanstep';
import Command_VMode from '../../Commands/Command_VMode';
import Command_VAmount from '../../Commands/Command_VAmount';
import Command_Freshup from '../../Commands/Command_Freshup';

export default class Add_Edit_Output_Action extends Component {
	constructor(props) {
		super(props);
		let selected_id = '';
		let action_details = {};
		this.action_index = 0;

		// To indicate if user is adding/editing action
		let add_action = false;

		if (this.props.param.action_index != null) {
			this.action_index = this.props.param.action_index;
			action_details = JSON.parse(JSON.stringify(this.props.param.program.action[this.action_index][1]));
			selected_id = this.props.param.program.action[this.action_index][0];
		} else {
			add_action = true;
			for (let point_id in window.app.state.point_list) {
				let point_info = window.app.state.point_list[point_id];
				// Selected target must be operationable
				if (point_info.op_cap) {
					selected_id = point_id;
					break;
				}
			}

			if (selected_id == '') {
				for (let group_id in this.props.param.groups) {
					selected_id = group_id;
					break;
				}
			}

			if (selected_id == '') {
				for (let scene_id in this.props.param.scenes) {
					selected_id = scene_id;
					break;
				}
			}

			if (selected_id == '') {
				for (let schedule_id in this.props.param.schedule.program) {
					selected_id = schedule_id;
					break;
				}
			}

			if (selected_id == '') {
				for (let interlock_id in this.props.param.interlock.program) {
					selected_id = interlock_id;
					break;
				}
			}

			if (this.props.param.program.action != null) this.action_index = this.props.param.program.action.length;
		}

		this.state = {
			selected_id: selected_id,
			action_details: action_details,
			add_action: add_action
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		param.op_type = 'output';
		this.props.content_handler('Interlock_Summary', param);
	}

	// Change Management point
	handleChangeMP = (selected_id) => {
		let action_details = {};
		let type_list = [];
		for (let i in this.props.param.program.action) {
			if (this.props.param.program.action[i][0] == selected_id) {
				window.app.showToast(this.props.receiver.getString('device_already_selected'), 3000);
				return;
			}
		}

		this.setState({
			selected_id: selected_id,
			action_details: action_details,
		})
	}

	// handle change Commands
	handleChangeStat = (stat) => {
		let action_details = this.state.action_details;
		if (stat != null) {
			action_details.stat = stat
		} else if (action_details.stat != null) {
			delete action_details.stat
		}

		this.setState({ action_details: action_details });
	}

	handleChangeMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.mode = val
		} else if (action_details.mode != null) {
			delete action_details.mode
		}

		this.setState({ action_details: action_details });
	}

	handleChangeSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sp = val
		} else if (action_details.sp != null) {
			delete action_details.sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeHumSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.hum_sp = val
		} else if (action_details.hum_sp != null) {
			delete action_details.hum_sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.fanstep = val
		} else if (action_details.fanstep != null) {
			delete action_details.fanstep
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFlap = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.flap = val
		} else if (action_details.flap != null) {
			delete action_details.flap
		}

		this.setState({ action_details: action_details });
	}

	handleChangeAV = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.av = val
		} else if (action_details.av != null) {
			delete action_details.av
		}

		this.setState({ action_details: action_details });
	}

	handleChangeNotification = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.notify = val
		} else if (action_details.notify != null) {
			delete action_details.notify
		}

		this.setState({ action_details: action_details });
	}

	handleChangeScene = (val) => {
		let action_details = this.state.action_details;

		if (val != null) {
			action_details.exec = val
		} else if (action_details.exec != null) {
			delete action_details.exec
		}

		this.setState({ action_details: action_details });
	}

	handleChangeSchedule = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.enable = val
		} else if (action_details.enable != null) {
			delete action_details.enable
		}

		this.setState({ action_details: action_details });
	}

	handleChangeInterlock = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.enable = val
		} else if (action_details.enable != null) {
			delete action_details.enable
		}

		this.setState({ action_details: action_details });
	}

	handleChangeLockStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.lock = val
		} else if (action_details.lock != null) {
			delete action_details.lock
		}
		this.setState({ action_details: action_details });
	}

	handleChangeShutterStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.shutter = val
		} else if (action_details.shutter != null) {
			delete action_details.shutter
		}
		this.setState({ action_details: action_details });
	}

	handleChangeRGB = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			val = val + "FF"; // add in W parameter
			let hex_code = val.substring(1); //remove # 
			let rgbw_code = parseInt(hex_code, 16); //Convert hexadecimal to decimal
			action_details.rgbw = rgbw_code
		} else if (action_details.rgbw != null) {
			delete action_details.rgbw
		}
		this.setState({ action_details: action_details });
	}

	handleChangeVMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.vmode = val
		} else if (action_details.vmode != null) {
			delete action_details.vmode
		}

		this.setState({ action_details: action_details });
	}

	handleChangeVAmount = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.vamount = val
		} else if (action_details.vamount != null) {
			delete action_details.vamount
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFreshup = (freshup) => {
		let action_details = this.state.action_details;
		if (freshup != null) {
			action_details.freshup = freshup
		} else if (action_details.freshup != null) {
			delete action_details.freshup
		}

		this.setState({ action_details: action_details });
	}

	handleChangeOffTimer = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.off_timer = val
		} else if (action_details.off_timer != null) {
			delete action_details.off_timer
		}

		this.setState({ action_details: action_details });
	}

	handleChangeCoolSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_csp = val
		} else if (action_details.sb_csp != null) {
			delete action_details.sb_csp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeHeatSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_hsp = val
		} else if (action_details.sb_hsp != null) {
			delete action_details.sb_hsp
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhOp = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rop_proh = val
		} else if (action_details.rop_proh != null) {
			delete action_details.rop_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rmode_proh = val
		} else if (action_details.rmode_proh != null) {
			delete action_details.rmode_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rsp_proh = val
		} else if (action_details.rsp_proh != null) {
			delete action_details.rsp_proh
		}

		this.setState({ action_details: action_details });
	}

	handleToggleRCProhFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rfan_proh = val
		} else if (action_details.rfan_proh != null) {
			delete action_details.rfan_proh
		}

		this.setState({ action_details: action_details });
	}

	handleRegister = () => {
		//If user is adding an action, upon pressing save, check if id already exist in program action
		if (this.state.add_action) {
			for (let i in this.props.param.program.action) {
				if (this.props.param.program.action[i][0] == this.state.selected_id) {
					window.app.showToast(this.props.receiver.getString('device_already_selected'), 3000);
					return;
				}
			}
		}

		if (isEmpty(this.state.action_details)) {
			window.app.showToast(this.props.receiver.getString('no_action'), 3000);
			return;
		}

		let program = this.props.param.program;
		program.action[this.action_index] = [];
		program.action[this.action_index].push(this.state.selected_id);
		program.action[this.action_index].push(this.state.action_details);
		this.props.content_handler('Interlock_Summary', { op_type: this.props.param.op_type, program: program, program_id: this.props.param.program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups, original_param: this.props.param.original_param });
	}

	handleDelete = () => {
		let program = JSON.parse(JSON.stringify(this.props.param.program));
		program.action.splice(this.action_index, 1);

		this.props.content_handler('Interlock_Summary', { op_type: this.props.param.op_type, program: program, program_id: this.props.param.program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups, original_param: this.props.param.original_param });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let action_details = this.state.action_details;
		/*
		 * Create target option selection
		 */
		const id_list = [];
		const mp_list = [];

		for (let point_id in window.app.state.point_list) {
			let point_info = window.app.state.point_list[point_id];

			if (point_info.op_cap) { // Only add in operation-able mangement points
				mp_list.push(<option value={point_id}>{point_info.name}</option>)
			}
		}
		id_list.push(<optgroup label={this.props.receiver.getString('devices')} >{mp_list}</optgroup>);

		const grp_list = [];
		for (let group_id in this.props.param.groups) {
			let group_info = this.props.param.groups[group_id];
			grp_list.push(<option value={group_id}>{this.props.receiver.getString(group_info.name)}</option>);
		}
		id_list.push(<optgroup label={this.props.receiver.getString('group')} >{grp_list}</optgroup>);

		const scene_list = [];
		for (let scene_id in this.props.param.scenes) {
			let scene_info = this.props.param.scenes[scene_id];
			scene_list.push(<option value={scene_id}>{scene_info.name}</option>);
		}
		id_list.push(<optgroup label={this.props.receiver.getString('scene')} >{scene_list}</optgroup>);

		const schedule_list = [];
		for (let schedule_id in this.props.param.schedule.program) {
			let schedule_info = this.props.param.schedule.program[schedule_id];
			schedule_list.push(<option value={schedule_id}>{schedule_info.name}</option>)
		}
		id_list.push(<optgroup label={this.props.receiver.getString('schedule')} >{schedule_list}</optgroup>);

		const interlock_list = [];
		for (let interlock_id in this.props.param.interlock.program) {
			let interlock_info = this.props.param.interlock.program[interlock_id];
			interlock_list.push(<option value={interlock_id}>{interlock_info.name}</option>)
		}
		id_list.push(<optgroup label={this.props.receiver.getString('interlock')} >{interlock_list}</optgroup>);

		/*
		 * Set which command can be shown
		 */
		// Ac
		let is_show_power = false;
		let is_show_setpoint = false;
		let is_show_fanstep = false;
		let is_show_flap = false;
		let is_show_mode = false;
		let is_show_off_timer = false;
		let is_show_sb = false;
		// Dehumi
		let is_show_hum_setpoint = false;
		// Rc_prohibit
		let is_show_rc_proh_op = false;
		let is_show_rc_proh_mode = false;
		let is_show_rc_proh_sp = false;
		let is_show_rc_proh_fanstep = false;
		// Hrv
		let is_show_vmode = false;
		let is_show_vamount = false;
		let is_show_freshup = false;
		// Level
		let is_show_level = false;
		// Others
		let is_show_notification = false;
		let is_show_scene = false;
		let is_show_schedule = false;
		let is_show_interlock = false;
		let is_show_lock = false;
		let is_show_shutter = false;
		let is_show_rgbw = false;

		let auth = this.props.receiver.active_controller.auth;
		let available_functions = this.props.receiver.active_controller.available_functions;

		if (window.app.state.point_list[this.state.selected_id] != null) {
			// Management point
			let point_info = window.app.state.point_list[this.state.selected_id];
			if (!isEmpty(point_info)) {
				if (point_info.op_cap) {
					switch (point_info.type) {
						case 'Ac':
							is_show_power = true;
							is_show_setpoint = getIsShowSetpoint(point_info, auth);
							is_show_fanstep = getIsShowFanstep(point_info);
							is_show_flap = getIsShowFlap(point_info);
							is_show_mode = getIsShowMode(point_info, auth);
							is_show_notification = true;
							is_show_off_timer = true;
							is_show_sb = getIsShowSB(available_functions);
							is_show_rc_proh_op = getIsShowRcProhOp(point_info, available_functions);
							is_show_rc_proh_mode = getIsShowRcProhMode(point_info, available_functions);
							is_show_rc_proh_sp = getIsShowRcProhSP(point_info, available_functions);
							is_show_rc_proh_fanstep = getIsShowRcProhFanstep(point_info, available_functions);
							break;
						case 'Dehumi':
							is_show_power = true;
							is_show_hum_setpoint = true;
							is_show_fanstep = true;
							is_show_off_timer = true;
							is_show_notification = true;
						case 'Switch':
							is_show_power = true;
							is_show_off_timer = true;
							break;
						case 'LevelSw':
							is_show_power = true;
							is_show_level = true;
							is_show_notification = true;
							is_show_off_timer = true;
							break;
						case 'Level':
							is_show_level = true;
							break;
						case 'Rgbw':
							is_show_power = true;
							is_show_rgbw = true;
							is_show_off_timer = true;
							break;
						case 'Hrv':
							is_show_power = true;
							is_show_vmode = getIsShowVMode(point_info);
							is_show_vamount = getIsShowVAmount(point_info);
							is_show_freshup = true;
							is_show_rc_proh_op = getIsShowRcProhOp(available_functions);
							is_show_off_timer = true;
							break;
						case 'Lock':
							is_show_lock = true;
							break;
						case 'Shutter':
							is_show_shutter = true;
							break;
					}
				}
			}
		} else if (this.props.param.groups[this.state.selected_id] != null) {
			//Group
			let group_info = this.props.param.groups[this.state.selected_id];
			for (let mp_id of group_info.mp) {
				let point_info = window.app.state.point_list[mp_id];
				if (!isEmpty(point_info)) {
					if (point_info.op_cap) {
						switch (point_info.type) {
							case 'Ac':
								is_show_power = true;
								if (!is_show_setpoint) is_show_setpoint = getIsShowSetpoint(point_info, auth);
								if (!is_show_fanstep) is_show_fanstep = getIsShowFanstep(point_info);
								if (!is_show_flap) is_show_flap = getIsShowFlap(point_info);
								if (!is_show_mode) is_show_mode = getIsShowMode(point_info, auth);
								is_show_notification = true;
								is_show_off_timer = true;
								if (!is_show_sb) is_show_sb = getIsShowSB(available_functions);
								if (!is_show_rc_proh_op) is_show_rc_proh_op = getIsShowRcProhOp(point_info, available_functions);
								if (!is_show_rc_proh_mode) is_show_rc_proh_mode = getIsShowRcProhMode(point_info, available_functions);
								if (!is_show_rc_proh_sp) is_show_rc_proh_sp = getIsShowRcProhSP(point_info, available_functions);
								if (!is_show_rc_proh_fanstep) is_show_rc_proh_fanstep = getIsShowRcProhFanstep(point_info, available_functions);
								break;
							case 'Dehumi':
								is_show_power = true;
								is_show_hum_setpoint = true;
								is_show_fanstep = true;
								is_show_off_timer = true;
								is_show_notification = true;
							case 'Switch':
								is_show_power = true;
								is_show_off_timer = true;
								break;
							case 'LevelSw':
								is_show_power = true;
								is_show_off_timer = true;
								is_show_notification = true;
								break;
							case 'Level':
								break;
							case 'Rgbw':
								is_show_power = true;
								is_show_rgbw = true;
								is_show_off_timer = true;
								break;
							case 'Hrv':
								is_show_power = true;
								if (!is_show_vmode) is_show_vmode = getIsShowVMode(point_info);
								if (!is_show_vamount) is_show_vamount = getIsShowVAmount(point_info);
								is_show_freshup = true;
								if (!is_show_rc_proh_op) is_show_rc_proh_op = getIsShowRcProhOp(point_info, available_functions);
								is_show_off_timer = true;
								break;
							//case 'Lock':
								//is_show_lock = true;
								//break;
							case 'Shutter':
								is_show_shutter = true;
								break;
						}
					}
				}
			}
		} else if (this.props.param.scenes[this.state.selected_id] != null) {
			// Scene
			is_show_scene = true;
		} else if (this.props.param.schedule.program[this.state.selected_id] != null) {
			// Schedule
			is_show_schedule = true;
		} else if (this.props.param.interlock.program[this.state.selected_id] != null) {
			// Interlock
			is_show_interlock = true;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.action_index != null ? this.props.receiver.getString('edit_action') : this.props.receiver.getString('add_action')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div id="scrollable-content" style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>
						<div id='id_list' style={{ marginLeft: 10, textAlign: 'center' }}>
							<div style={{ width: this.props.width - 20 }}>
								<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('choose_device')}</span>
							</div>
							<div style={{ width: this.props.width - 20 }}>
								<Select
									style={{ verticalAlign: 'top', }}
									select_style={{ fontSize: 20, height: 35 }}
									options={id_list}
									value={this.state.selected_id}
									onSelect={this.handleChangeMP}
								/>
							</div>
						</div>

						<div id='power' style={{ display: is_show_power ? 'block' : 'none' }}>
							<Command_Power receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeStat={this.handleChangeStat} />
						</div>
						<div id='sp' style={{ display: is_show_setpoint ? 'block' : 'none' }}>
							<Command_Setpoint point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeSP={this.handleChangeSP} />
						</div>
						<div id='hum_sp' style={{ display: is_show_hum_setpoint ? 'block' : 'none' }}>
							<Command_Hum_Setpoint point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHumSP={this.handleChangeHumSP} />
						</div>
						<div id='mode' style={{ display: is_show_mode ? 'block' : 'none' }}>
							<Command_Mode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeMode={this.handleChangeMode} />
						</div>
						<div id='fanstep' style={{ display: is_show_fanstep ? 'block' : 'none' }}>
							<Command_Fanstep point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFanstep={this.handleChangeFanstep} />
						</div>
						{/* Flap not required by interlock output */}
						{/* <div id='flap' style={{ display: is_show_flap ? 'block' : 'none' }}>
							<Command_Flap point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFlap={this.handleChangeFlap} />
						</div> */}
						<div id='off_timer' style={{ display: is_show_off_timer ? 'block' : 'none' }}>
							<Command_Off_Timer receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeOffTimer={this.handleChangeOffTimer} />
						</div>
						<div id='sb_cool' style={{ display: is_show_sb ? 'block' : 'none' }}>
							<Command_Setback_Cool point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeCoolSetback={this.handleChangeCoolSetback} />
						</div>
						<div id='sb_heat' style={{ display: is_show_sb ? 'block' : 'none' }}>
							<Command_Setback_Heat point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHeatSetback={this.handleChangeHeatSetback} />
						</div>
						<div id='rc_proh_op' style={{ display: is_show_rc_proh_op ? 'block' : 'none' }}>
							<Command_RC_Proh_Op receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhOp={this.handleToggleRCProhOp} />
						</div>
						<div id='rc_proh_mode' style={{ display: is_show_rc_proh_mode ? 'block' : 'none' }}>
							<Command_RC_Proh_Mode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhMode={this.handleToggleRCProhMode} />
						</div>
						<div id='rc_proh_sp' style={{ display: is_show_rc_proh_sp ? 'block' : 'none' }}>
							<Command_RC_Proh_SP receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhSP={this.handleToggleRCProhSP} />
						</div>
						<div id='rc_proh_fanstep' style={{ display: is_show_rc_proh_fanstep ? 'block' : 'none' }}>
							<Command_RC_Proh_Fanstep receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhFanstep={this.handleToggleRCProhFanstep} />
						</div>
						<div id='level' style={{ display: is_show_level ? 'block' : 'none' }}>
							<Command_Level point_id={this.state.selected_id} point_info={null} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeAV={this.handleChangeAV} />
						</div>
						<div id='notifications' style={{ display: is_show_notification ? 'block' : 'none' }}>
							<Command_Notification receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeNotification={this.handleChangeNotification} />
						</div>
						<div id='Scene' style={{ display: is_show_scene ? 'block' : 'none' }}>
							<Command_Scene selected_id={this.state.selected_id} scenes={this.props.param.scenes} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeScene={this.handleChangeScene} />
						</div>
						<div id='Schedule' style={{ display: is_show_schedule ? 'block' : 'none' }}>
							<Command_Schedule receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeSchedule={this.handleChangeSchedule} />
						</div>
						<div id='Interlock' style={{ display: is_show_interlock ? 'block' : 'none' }}>
							<Command_Interlock receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeInterlock={this.handleChangeInterlock} />
						</div>
						<div id='lock' style={{ display: is_show_lock ? 'block' : 'none' }}>
							<Command_Lock receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeLockStatus={this.handleChangeLockStatus} />
						</div>
						<div id='shutter' style={{ display: is_show_shutter ? 'block' : 'none' }}>
							<Command_Shutter receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeShutterStatus={this.handleChangeShutterStatus} />
						</div>
						<div id='rgbw' style={{ display: is_show_rgbw ? 'block' : 'none' }}>
							<Command_RGB_Input receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeRGB={this.handleChangeRGB} />
						</div>
						<div id='vmode' style={{ display: is_show_vmode ? 'block' : 'none' }}>
							<Command_VMode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeVMode={this.handleChangeVMode} />
						</div>
						<div id='vamount' style={{ display: is_show_vamount ? 'block' : 'none' }}>
							<Command_VAmount receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeVAmount={this.handleChangeVAmount} />
						</div>
						<div id='freshup' style={{ display: is_show_freshup ? 'block' : 'none' }}>
							<Command_Freshup receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFreshup={this.handleChangeFreshup} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}